module.exports = __webpack_public_path__ + "img/FR16188.f37986d0.png";